import { zodResolver } from '@hookform/resolvers/zod';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { EmailCampaignContent } from './EmailCampaignContent';
import { EMAIL_CAMPAIGN_FORM_SCHEMA, EmailCampaignFormInput, EmailCampaignFormOutput } from './EmailCampaignValidation';
import { EmailCampaignMode } from './EmailCampaignSteps';

type EmailCampaignProps = {
  mode?: EmailCampaignMode;
  campaignId?: string;
  onExitToList?: () => void;
};

export const EmailCampaign: FC<EmailCampaignProps> = ({ mode = 'create', campaignId, onExitToList }) => {
  const methods = useForm<EmailCampaignFormInput, unknown, EmailCampaignFormOutput>({
    resolver: zodResolver(EMAIL_CAMPAIGN_FORM_SCHEMA),
    defaultValues: {
      name: '',
      description: '',
      templateId: '',
      templateName: undefined,
      audienceId: '',
      connectorFlowId: '',
      connectorId: '',
      scheduleType: 'sendNow',
      scheduleStart: undefined,
      scheduleEnd: undefined,
    },
    mode: 'onTouched',
  });

  const onSubmit = (_data: EmailCampaignFormOutput) => {
    // Submit is intentionally controlled by step actions.
  };

  return (
    <FormProvider {...methods}>
      <form className='flex min-h-full flex-col gap-6 p-8' onSubmit={methods.handleSubmit(onSubmit)}>
        <EmailCampaignContent mode={mode} campaignId={campaignId} onExitToList={onExitToList} />
      </form>
    </FormProvider>
  );
};
